<template>
  <v-container fluid class="container-pdpa-alert">
    <v-layout md1 pd1 mb-4>
      <v-card dark width="100%" class="card">
        <v-card-title>
          <v-flex style="font-size:26px;" class="text-xs-left">
            <span>Alert History</span>
          </v-flex>
        </v-card-title>
      </v-card>
    </v-layout>

    <v-layout justify-start column fill-height mb-4>
      <v-tabs slot="extension" v-model="tabIndex" color="dark" dark id="tab-menu-pdpa">
        <v-tabs-slider color="yellow" />
        <v-tab
          v-for="item in tabMenu"
          :key="item"
          style="text-transform: capitalize;"
        >{{ item }}</v-tab>
      </v-tabs>
    </v-layout>

    <!-- Dialog Activity Alert  Details -->
    <div class="text-xs-center">
        <v-dialog
        v-model="isDialogATAlertDetailShown"
        width="1024"
        persistent
            >
            <v-card class="grey darken-1">
                <v-card-title
                  class="headline grey darken-4"
                  style="color: #cccccc;"
                  primary-title
                >
                  Alert Details
                <v-spacer />
                    <v-btn icon dark @click="isDialogATAlertDetailShown = false" style="outline: none;">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="text-md-left grey lighten-4" id="atDetail">
                  <span class="blockheading">แจ้งเตือนวันที่/เวลา : </span> <span class="blockresult" @click="toSearchAT(period, '1')">{{datetime}}</span><br>
                  <span class="blockheading">ช่วงเวลา(Query log) : </span> <span class="blockresult" @click="toSearchAT(period, '2')">{{period}}</span>
                  <!-- <h4 style="color: #E57373;">{{msg}}</h4> -->
                </v-card-text>
                <v-card-text class="text-md-left grey lighten-4" id="atResult">
                  <h4 style="color: #EF5350; margin-bottom: 15px;">{{msg}}</h4>
                  <v-layout column justify-center v-for="(item, index) in seedetail" :key="index">
                    <v-expansion-panel expand >
                      <v-expansion-panel-content class="grey lighten-2">
                        <template v-slot:actions>
                          <v-icon >expand_more</v-icon>
                        </template>
                        <template v-slot:header>
                          <h5 style="color: #424242;">Host: {{item.hostname}}</h5>
                        </template>
                        <v-layout column justify-center mx-0>
                          <v-flex px-4 class="grey lighten-3" py-3>
                            <v-data-table
                                :headers="headerDetail"
                                :items="item.event"
                                :pagination.sync="paginationATDetail"
                                hide-actions>
                              <template slot="headerCell" slot-scope="props">
                                  <span>{{ props.header.text }}</span>
                              </template>
                              <template slot="items" slot-scope="props">
                                <tr>
                                  <td class="text-xs-center grey lighten-4" style="color:red;"><span style="cursor: pointer; text-decoration-line: underline;" @click="toSearchAT(props.item.username, '3')">{{ props.item.username }}</span></td>
                                  <td class="text-xs-center grey lighten-4"><span style="color:#26A69A;">{{ props.item.eventcount }}</span></td>
                                  <td class="justify-center layout px-0 grey lighten-4">
                                    <v-tooltip bottom>
                                      <v-btn
                                          slot="activator"
                                          flat
                                          icon
                                          style="outline: none;"
                                          @click="addUser(props.item,item.hostname)">
                                          <v-icon size="21">person_add_alt_1</v-icon>
                                      </v-btn>
                                      <span>Add to whitelist</span>
                                    </v-tooltip>
                                  </td>
                                </tr>
                              </template>
                            </v-data-table>
                            <span class="recommend">* Click result in column for search more ...</span>
                          </v-flex>
                        </v-layout>
                    </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>

    <!-- Dialog Confirm Add Activity -->
    <div class="text-xs-center">
        <v-dialog
        v-model="isDialogConfirmAdduserShown"
        persistent
        width="500"
        >
        <v-card>
            <v-card-title
              class="headline grey darken-4"
              style="color: #cccccc;"
              primary-title
            >
              Confirm Add User
            </v-card-title>

            <v-card-text class="text-md-left">
                <p>Are you sure add user to whitelist <span style="color: green;">Yes</span> or <span style="color: red;">No</span> ? </p>
            </v-card-text>

            <v-card-actions>
            <v-spacer />
            <v-btn
                color="text-light red darken-1"
                style="outline: none;"
                @click="isDialogConfirmAdduserShown = false"
            >
                No
            </v-btn>
            <v-btn
                class="text-light green darken-2"
                style="outline: none;"
                @click="addUserToWhitelist()"
            >
                Yes
            </v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
    </div>

    <!-- Dialog PDPA Alert Details -->
    <div class="text-xs-center">
        <v-dialog
          v-model="isDialogPAAlertDetailShown"
          width="1024"
          persistent
            >
            <v-card class="grey darken-2">
                <v-card-title
                  class="headline grey darken-4"
                  style="color: #cccccc;"
                  primary-title
                >
                  Alert Details
                <v-spacer />
                    <v-btn icon dark @click="isDialogPAAlertDetailShown = false" style="outline: none;">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="text-md-left">
                  <v-expansion-panel v-model="panel1">
                    <v-expansion-panel-content class="grey lighten-1">
                      <template v-slot:actions>
                        <v-icon >expand_more</v-icon>
                      </template>
                      <template v-slot:header>
                        <span>Setting</span>
                      </template>
                      <v-layout align-star justify-space-between mx-0 mb-0 style="padding:20px" class="grey lighten-3">
                        <table class="table-detail">
                          <tr>
                            <td>Alert Name : <span>{{alertname}}</span></td>
                            <td>Alert Status : <span>{{status}}</span></td>
                            <td>Device : <span>{{alertdevice}}</span></td>
                            <td>Query By : <span style="cursor: pointer; color: #0091EA !important; text-decoration-line: underline;"
                                @click="toSearch(query, '1')">
                                {{ query.toString().split('text: ')[1] }}
                                <span id="new">click !</span>
                              </span>
                            </td>
                            <td>Event type : <span @click="toSearch">{{type}}</span></td>
                          </tr>
                          <tr>
                            <td>Field To Use Alert :
                              <span v-if="type == 'count'">{{field}}</span>
                              <span v-else>{{fieldalert}}</span>
                            </td>
                            <td>Alert Rule : <span>{{rule}}</span></td>
                            <td>Run Alert Every : <span>{{time}}</span></td>
                            <td>Alert To : <span>{{email}}</span></td>
                          </tr>
                        </table>
                      </v-layout>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel v-model="panel2">
                    <v-expansion-panel-content class="grey lighten-1">
                      <template v-slot:actions>
                        <!-- <v-icon v-if="panel == null">add_circle_outline</v-icon>
                        <v-icon v-else>remove_circle_outline</v-icon> -->
                        <v-icon >expand_more</v-icon>
                      </template>
                      <template v-slot:header>
                        <div>Alert</div>
                      </template>
                      <v-card class="grey lighten-3" id="seedetail-panel2">
                        <v-card-text>แจ้งเตือนวันที่/เวลา : <span style="color: #26A69A; font-size: 16px; margin-left: 9px;">{{datetime}}</span></v-card-text>
                        <v-card-text>ช่วงเวลา(Query log) : <span style="color: #26A69A; font-size: 16px; margin-left: 9px;">{{range}}</span></v-card-text>
                        <v-card-text>Alert Result : <span style="color: #26A69A; font-size: 16px; margin-left: 9px;">{{total}}</span></v-card-text>
                      </v-card>
                      <v-layout column justify-center mx-0>
                         <v-flex px-3 class="grey lighten-3">
                            <v-data-table
                                :headers="headerDetail"
                                :items="seedetail"
                                :pagination.sync="paginationdetail"
                                hide-actions>
                              <template slot="items" slot-scope="props">
                                  <tr>
                                    <td class="text-xs-center grey lighten-4"><span style="cursor: pointer; color: #EF5350 !important; text-decoration-line: underline;" @click="toSearch(props.item.key, '2')">{{ props.item.key }}</span></td>
                                    <td class="text-xs-center grey lighten-4"><span style="color: #26A69A;">{{ props.item.doc_count }}</span></td>
                                  </tr>
                              </template>
                            </v-data-table>
                            <span class="recommend">* Click result in column for search more ...</span>
                         </v-flex>
                      </v-layout>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>

    <!-- Dialog Confirm Delete alert PA -->
    <div class="text-xs-center">
        <v-dialog
          v-model="isDialogConfirmDeleteShown"
          width="500"
        >
        <v-card>
            <v-card-title
                class="headline grey darken-4"
                style="color: #cccccc;"
                primary-title
            >
                Confirm Delete Alert
            </v-card-title>

           <v-card-text class="text-md-left">
              <br>
              <p style="font-size: 16px;">Are you sure delete selected {{ selected.length }} {{selected.length === 1 ? 'item' : 'items'}} ?</p>
            </v-card-text>

            <v-card-actions>
            <v-spacer />
            <v-btn
                color="red"
                style="outline: none;"
                outline
                @click="isDialogConfirmDeleteShown = false"
            >
                No
            </v-btn>
            <v-btn
                class="text-light green darken-2"
                style="outline: none;"
                @click="deleteAlertPA"
            >
                Yes
            </v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
    </div>

    <!-- Dialog Confirm Delete alert AT -->
    <div class="text-xs-center">
        <v-dialog
          v-model="isDialogConfirmDeleteATShown"
          width="500"
        >
        <v-card>
            <v-card-title
                class="headline grey darken-4"
                style="color: #cccccc;"
                primary-title
            >
                Confirm Delete Alert
            </v-card-title>

            <v-card-text class="text-md-left">
              <br>
              <p style="font-size: 16px;">Are you sure delete selected {{ selected.length }} {{selected.length === 1 ? 'item' : 'items'}} ?</p>
            </v-card-text>

            <v-card-actions>
            <v-spacer />
            <v-btn
                color="red"
                style="outline: none;"
                outline
                @click="isDialogConfirmDeleteATShown = false"
            >
                No
            </v-btn>
            <v-btn
                class="text-light green darken-2"
                style="outline: none;"
                @click="deleteAlertAT"
            >
                Yes
            </v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
    </div>

    <!-- iLog TCCA Alert History  Table -->
    <v-layout v-if="tabIndex == 0" id="data-table-pdpa">
        <v-flex lg12 md12>
            <v-card dark>
                <v-card-title id="search-bar">
                  <v-flex ml-0>
                    <v-flex class="tine_header">Date Filter</v-flex>
                    <v-flex row ml-0 style="flex-wrap: nowrap;">
                      <v-flex lg5 md5>
                        <VueCtkDateTimePicker
                          id="DateTimePickerST"
                          v-model="abStartTime"
                          color="#1B4A86"
                          label="Start Time"
                          format="YYYY-MM-DDTHH:mm:ss"
                          dark/>
                      </v-flex>
                      <v-flex lg1 md1 mt-2 style="color: #cccccc;">
                        <p>To</p>
                      </v-flex>
                      <v-flex lg5 md5>
                        <VueCtkDateTimePicker
                          id="DateTimePickerEND"
                          v-model="abEndTime"
                          color="#1B4A86"
                          label="End Time"
                          format="YYYY-MM-DDTHH:mm:ss"
                          dark/>
                      </v-flex>
                      <v-flex md1 lg1 ml-2 style="position: relative; text-align: left;">
                        <button
                          style="height: 42px;"
                          class="btn bg-success font-weight-bold text-white"
                          type="submit"
                          @click="showFilter">
                            Submit
                        </button>
                      </v-flex>
                  </v-flex>
                </v-flex>
                <v-spacer />
                <v-flex lg1 md1 style="top: 10px; position: relative; margin-right: 20px;">
                  <v-select
                    v-model="device"
                    :items="devices"
                    label="Device"
                  />
                </v-flex>
                <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    style="width: 30px"
                    single-line
                    hide-details />
                </v-card-title>
                <v-flex left md2 ml-3>
                  <v-btn
                    slot="activator"
                    color="red lighten-2"
                    :disabled="selected.length == 0"
                    style="text-transform: none !important; outline: none;"
                    dark
                    round
                    small
                    @click="isDialogConfirmDeleteShown = true"
                  >
                  <v-icon size="22">delete</v-icon>
                    Delete selected
                  </v-btn>
                </v-flex>
                <v-data-table
                    v-model="selected"
                    :headers="headerPdpaAlert"
                    :items="datatablesPdpaAlert"
                    :loading="loadTablePdpaAlert"
                    :pagination.sync="paginationPA"
                    item-key="_id"
                    select-all
                    hide-actions
                >
                <v-progress-linear slot:progress color="blue" indeterminate></v-progress-linear>
                <template slot="items" slot-scope="props">
                    <tr>
                      <td>
                        <v-checkbox
                          v-model="props.selected"
                          primary
                          hide-details
                        ></v-checkbox>
                      </td>
                      <td class="text-xs-left">{{ props.item.datetime }}</td>
                      <td class="text-xs-left">{{ props.item.range }}</td>
                      <td class="text-xs-left">{{ props.item.name }}</td>
                      <td class="text-xs-left">{{ props.item.device }}</td>
                      <td class="justify-center layout px-0">
                        <v-icon small class="mr-2" @click="seeDetails(props.item, 'PA')" id="table-seedetail">
                        <!-- <v-icon small class="mr-2" @click="props.expanded = !props.expanded, pmAlert = false"> -->
                          visibility
                        </v-icon>
                      </td>
                    </tr>
                </template>

                <template v-slot:no-results>
                    <v-alert :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                    </v-alert>
                </template>
                </v-data-table>
                <v-layout align-center justify-center row fill-height>
                    <div class="text-xs-center" style="margin-top: 15px; height: 60px;">
                        <v-pagination
                            v-model="page"
                            :length="allPages"
                            :total-visible="total_visible"
                        ></v-pagination>
                    </div>
                    <div class="text-xs-center"
                    style="position: absolute; display:flex; flex-direction: row; width: 130px; right: 30px;">
                    <span style="width: 100px; align-self: center; margin: 0 15px;">page</span>
                    <v-text-field
                      v-model="gotoPage"
                      class="gopage"
                      :append-outer-icon="'chevron_right'"
                      @click:append-outer="goto"
                      @keyup.enter="goto"
                    />
                  </div>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>

    <!-- iLog PDPA Alert History Activity tracking Table -->
    <v-layout v-if="tabIndex == 1">
        <v-flex lg12 md12>
            <v-card dark>
                <v-card-title id="tab-search-at">
                <!-- <v-spacer /> -->
                  <v-flex>
                    <v-flex class="tine_header">Date Filter</v-flex>
                    <v-flex row ml-0 style="flex-wrap: nowrap;">
                      <v-flex lg5 md5>
                        <VueCtkDateTimePicker
                          id="DateTimePickerST"
                          v-model="abStartTime"
                          color="#1B4A86"
                          label="Start Time"
                          format="YYYY-MM-DDTHH:mm:ss"
                          dark/>
                      </v-flex>
                      <v-flex lg1 md1 mt-2 style="color: #cccccc;">
                        <p>To</p>
                      </v-flex>
                      <v-flex lg5 md5>
                        <VueCtkDateTimePicker
                          id="DateTimePickerEND"
                          v-model="abEndTime"
                          color="#1B4A86"
                          label="End Time"
                          format="YYYY-MM-DDTHH:mm:ss"
                          dark/>
                      </v-flex>
                      <v-flex md1 lg1 ml-2 style="position: relative; text-align: left;">
                        <button
                          style="height: 42px;"
                          class="btn bg-success font-weight-bold text-white"
                          type="submit"
                          @click="showFilter">
                            Submit
                        </button>
                      </v-flex>
                    </v-flex>
                  </v-flex>
                  <v-spacer />
                  <v-text-field
                      v-model="search"
                      append-icon="search"
                      label="Search"
                      style="width: 30px"
                      single-line
                      hide-details
                  />
                </v-card-title>
                <v-flex left md2 ml-3>
                  <v-btn
                    slot="activator"
                    color="red lighten-2"
                    :disabled="selected.length == 0"
                    style="text-transform: none !important; outline: none;"
                    dark
                    round
                    small
                    @click="isDialogConfirmDeleteATShown = true"
                  >
                  <v-icon size="22">delete</v-icon>
                    Delete selected
                  </v-btn>
                </v-flex>
                <v-data-table
                    v-model="selected"
                    :headers="header"
                    :items="datatables"
                    :loading="loadTable"
                    :pagination.sync="paginationAT"
                    item-key="_id"
                    select-all
                    hide-actions
                >
                <v-progress-linear slot:progress color="blue" indeterminate></v-progress-linear>
                <template slot="items" slot-scope="props">
                    <td>
                      <v-checkbox
                        v-model="props.selected"
                        primary
                        hide-details
                      ></v-checkbox>
                    </td>
                    <td class="text-xs-left">{{ props.item.datetime }}</td>
                    <td class="text-xs-left">{{ props.item.period }}</td>
                    <td class="text-xs-left">{{ props.item.hostname }}</td>
                    <td class="justify-center layout px-0">
                      <v-icon small class="mr-2" @click="seeDetails(props.item, 'AT')">
                        visibility
                      </v-icon>
                    </td>
                </template>
                <template v-slot:no-results>
                    <v-alert :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                    </v-alert>
                </template>
                </v-data-table>
                <v-layout align-center justify-center row fill-height>
                    <div class="text-xs-center" style="margin-top: 15px; height: 60px;">
                        <v-pagination
                            v-model="page"
                            :length="allPages"
                            :total-visible="total_visible"
                        ></v-pagination>
                    </div>
                    <div class="text-xs-center"
                    style="position: absolute; display:flex; flex-direction: row; width: 130px; right: 30px;">
                    <span style="width: 100px; align-self: center; margin: 0 15px;">page</span>
                    <v-text-field
                      v-model="gotoPage"
                      class="gopage"
                      :append-outer-icon="'chevron_right'"
                      @click:append-outer="goto"
                      @keyup.enter="goto"
                    />
                  </div>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>

    <v-snackbar
        v-model="snackbar"
        :bottom="false"
        :left="false"
        :multi-line="true"
        :right="false"
        :timeout="5000"
        :top="true"
        :vertical="false">
    {{ snackbartext }}
        <v-btn
            color="pink"
            flat
            style="outline: none;"
            @click="snackbar = false">
        Close
        </v-btn>
    </v-snackbar>
    <v-tour name="recommand-tour-al-pdpa" :steps="steps" :options="stepOptions" :callbacks="stepCallbacks">
      <template slot-scope="tour">
        <transition name="fade"></transition>
          <v-step
            v-if="tour.steps[tour.currentStep]"
            :key="tour.currentStep"
            :step="tour.steps[tour.currentStep]"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :skip="tour.skip"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
            :highlight="tour.highlight"
            class="tour-body"
          >
            <template>
              <v-layout slot="header" class="tour-header">
                <img v-if="tour.currentStep == 0" src="../assets/img/login/logo-ilog-256.png" alt="ilog_logo" style="width: 21px; height: 21px; position: relative; top: 5px; left: 50px;">
                <v-icon v-if="tour.currentStep == 1" style="position: relative; left: 130px; color: #fff;">search</v-icon>
                <v-icon v-if="tour.currentStep == 2" style="position: relative; left: 60px; color: #fff;">visibility</v-icon>
                <v-icon v-if="tour.currentStep == 3" style="position: relative; left: 130px; color: #fff;">settings</v-icon>
                <v-icon v-if="tour.currentStep == 4" style="position: relative; left: 55px; color: #fff;">table_chart</v-icon>
                <v-icon v-if="tour.currentStep == 5" style="position: relative; left: 90px; color: #fff;">timeline</v-icon>
                <v-icon v-if="tour.currentStep == 6" style="position: relative; left: 120px; color: #fff;">access_time</v-icon>
                <v-icon v-if="tour.currentStep == 7" style="position: relative; left: 55px; color: #fff;">table_chart</v-icon>
                <v-icon v-if="tour.currentStep == 8" style="position: relative; left: 110px; color: #fff;">chat</v-icon>
                <v-flex class="headline font-weight-light" v-html="tour.steps[tour.currentStep].header.title"></v-flex>
              </v-layout>
              <v-layout slot="content" class="tour-content" column>
                <v-flex class="body-2 font-weight-light" my-2>( {{tour.currentStep + 1}} / {{tour.steps.length}} )</v-flex>
                <v-flex class=" body-2 font-weight-light" v-html="tour.steps[tour.currentStep].content" ></v-flex>
              </v-layout>
              <v-layout slot="actions" fill-height align-center justify-center row>
                <v-flex v-if="tour.currentStep == 0" mt-2>
                  <v-btn @click="tour.nextStep" class="tour-btn-start font-weight-regular" block>Start</v-btn>
                  <button @click="tour.skip" class="tour-btn-skip">Skip</button>
                </v-flex>
                <v-flex v-else-if="!tour.isLast" column mt-3>
                  <v-btn @click="tour.previousStep" class="tour-btn-back font-weight-regular" round>Back</v-btn>
                  <v-btn @click="tour.nextStep" class="tour-btn-next font-weight-regular" round>Next</v-btn><br>
                  <button @click="tour.skip" class="tour-btn-skip">Skip</button>
                </v-flex>
                <v-flex v-else>
                  <v-btn @click="tour.finish" class="tour-btn-finish" block>Finish</v-btn>
                </v-flex>
                <!-- <v-btn @click="tour.skip" class="tour-btn"  block round>ข้าม</v-btn>
                <v-btn v-if="!tour.isFirst" @click="tour.previousStep" class="tour-btn" block round>ย้อนกลับ</v-btn>
                <v-btn v-if="!tour.isLast" @click="tour.nextStep" class="tour-btn" block round>ต่อไป</v-btn>
                <v-btn v-if="tour.isLast" @click="tour.finish" class="tour-btn" block round>สิ้นสุด</v-btn> -->
              </v-layout>
            </template>
          </v-step>
      </template>
    </v-tour>
  </v-container>
</template>

<script>
import axios from 'axios'
import jwtDecode from 'jwt-decode'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
export default {
    name: 'alertHistoryPDPA',
    components: {
      VueCtkDateTimePicker
    },
    data () {
       return {
        page: 1,
        perPage: 10,
        allPages: null,
        total_visible: 10,
        gotoPage: 1,
        tabMenu: ['PDPA alert', 'Activity tracking'],
        tabIndex: 0,
        snackbar: false,
        snackbartext: '',
        selected: [],
        hostname: '',
        username: '',
        period: '',
        datetime: '',
        seedetail: [],
        msg: 'แจ้งเตือนการละเมิดเข้าถึงข้อมูลสวนบุคคล',
        atePickerOpt: {
          format: 'YYY-MM-DD hh:mm a',
          useCurrent: false,
          showClear: true,
          showClose: true
        },
        abStartTime: '',
        abEndTime: '',
        startTime: '',
        endTime: '',
        showFilterData: false,
        header: [
          {
            text: 'Date/Time',
            value: 'datetime',
            align: 'left',
            sortable: false
          },
          {
            text: 'Time period(Query log)',
            value: 'period',
            align: 'left',
            sortable: false
          },
          {
            text: 'Hostname',
            value: 'hostname',
            align: 'left',
            sortable: false
          },
          {
            text: 'Details',
            value: 'details',
            align: 'center',
            sortable: false
          }
        ],
        headerDetail: [],
        datatablesDetail: [],
        datatables: [],
        search: '',
        loadTable: false,
        paginationAT: {
          descending: true,
          rowsPerPage: 10,
          sortBy: 'order'
        },
        paginationPA: {
          descending: true,
          rowsPerPage: 10,
          sortBy: 'time'
        },
        paginationdetail: {
          descending: false,
          rowsPerPage: 100,
          sortBy: 'key'
        },
        paginationATDetail: {
          descending: true,
          rowsPerPage: 100,
          sortBy: 'eventcount'
        },
        isDialogATAlertDetailShown: false,
        isDialogPAAlertDetailShown: false,
        isDialogConfirmAdduserShown: false,
        isDialogConfirmDeleteShown: false,
        isDialogConfirmDeleteATShown: false,
        headerPdpaAlert: [
          {
            text: 'Date/Time',
            value: 'datetime',
            align: 'left',
            sortable: false
          },
          {
            text: 'Time period(Query log)',
            value: 'range',
            align: 'left',
            sortable: false
          },
          {
            text: 'Alert Name',
            value: 'name',
            align: 'left',
            sortable: false
          },
          {
            text: 'Device',
            value: 'device',
            align: 'left',
            sortable: false
          },
          {
            text: 'Details',
            value: 'details',
            align: 'center',
            sortable: false
          }
        ],
        datatablesPdpaAlert: [],
        device: 'All',
        devices: ['All'],
        loadTablePdpaAlert: false,
        user_id: '',
        panel1: [],
        panel2: [],
        panel: [],
        alertname: '',
        status: '',
        alertdevice: '',
        total: '',
        range: '',
        query: '',
        type: '',
        field: '',
        fieldalert: '',
        rule: '',
        time: '',
        email: '',
        user: '',
        searchFromAlert: '',
        finishLoadAlertPDPA: false,
        finishLoadAlertAT: false,
        ampid: '',
        recommend: false,
        stepOptions: {
          useKeyboardNavigation: true,
          highlight: true,
          labels: {
            buttonSkip: 'Skip tour',
            buttonPrevious: 'Previous',
            buttonNext: 'Next',
            buttonStop: 'Finish'
          }
        },
        stepCallbacks: {
          onSkip: this.finishStepTour,
          onFinish: this.finishStepTour
        },
        steps: [
          {
            target: '#search-bar',
            header: {
              title: 'Get Started with iLog 2.6'
            },
            content: `<h5>พบกับฟีเจอร์ใหม่ Alert history</h5><span>ที่คุณสามารถดูรายละเอียดการแจ้งเตือนย้อนหลังทั้งหมดที่คุณได้ตั้งค่าไว้ <br>ทั้งจาก PDPA และ Activity tracking</span>`,
            params: {
              placement: 'top',
              highlight: false,
              enableScrolling: false
            },
            before: () => {
              this.datatablesPdpaAlert = [
                {
                  _id: '60a7774405511a50ec6764b',
                  datetime: 'Fri May 21 2021 17:30:00 GMT+0700 (เวลาอินโดจีน)',
                  device: 'fileshare',
                  name: 'Top 5 ผู้ที่มีการ download เยอะที่สุดแต่ละวัน',
                  range: '21/05  08:30 น.   -  21/05  17:30 น.',
                  event: [
                    {
                      id: '60a7774405511a50ec6764d3',
                      total: '2352.98',
                      alertbox: {
                        _id: '60a7771805511a50ec676624',
                        action: 'Email',
                        alertid: '6093bba99046a230f84dc5bp',
                        email: 'example@email.co.th',
                        eventTrigger: 'download',
                        fieldalet: 'username',
                        intervals: '*/1 * * * *',
                        name: 'Top 5 ผู้ที่มีการ download เยอะที่สุดแต่ละวัน',
                        query: ['text: 192.168.200*'],
                        raw_interval: '1  d',
                        selectedIndex: 'fileshare',
                        targetField: 'username',
                        trigger: 'Greater than  500',
                        unit: 'MB'
                      },
                      data: [
                        {
                          _id: '60a7774405511a50ec6766e1',
                          key: 'Username 1',
                          doc_count: '2545.30 MB'
                        },
                        {
                          _id: '60a7774405511a50ec6766e2',
                          key: 'Username 2',
                          doc_count: '1365.04 MB'
                        },
                        {
                          _id: '60a7774405511a50ec6766e3',
                          key: 'Username 3',
                          doc_count: '661.94 MB'
                        },
                        {
                          _id: '60a7774405511a50ec6766e3',
                          key: 'Username 4',
                          doc_count: '1354.94 MB'
                        },
                        {
                          _id: '60a7774405511a50ec6766e3',
                          key: 'Username 5',
                          doc_count: '987.94 MB'
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          },
          {
            target: '#search-bar',
            header: {
              title: 'เมนูค้นหา'
            },
            content: `<span>พร้อมเมนูฟิลเตอร์ข้อมูลให้ได้ตามที่คุณต้องการ <br>ทั้งวันที่, อุปกรณ์ หรือ keyword สำคัญตามที่คุณต้องการ</span>`,
            params: {
              highlight: true,
              enableScrolling: false
            }
          },
          {
            target: '#table-seedetail',
            header: {
              title: 'ปุ่มดูรายละเอียดเพิ่มเติม'
            },
            content: `<span>สามารถกดดูรายละเอียดเพิ่มเติมได้ที่นี่</span>`,
            params: {
              placement: 'left',
              highlight: false,
              enableScrolling: false
            },
            before: () => {
              this.isDialogPAAlertDetailShown = false
              this.panel2 = null
              this.panel2 = null
            }
          },
          {
            target: '.table-detail',
            header: {
              title: 'การตั้งค่า'
            },
            content: `<span>แท็บนี่จะเป็นส่วนที่แสดงรายละเอียดการตั้งค่าการแจ้งเตือนของคุณ</span>`,
            params: {
              highlight: true,
              enableScrolling: false
            },
            before: () => {
              this.seeDetails(this.datatablesPdpaAlert[0], 'PA')
              this.panel1 = 0
            }
          },
          {
            target: '#seedetail-panel2',
            header: {
              title: 'รายละเอียดผลการทำงาน'
            },
            content: `<span>แท็บนี่จะเป็นส่วนที่แสดงผลการทำงาน</span>`,
            params: {
              highlight: false,
              enableScrolling: false
            },
            before: () => {
              this.panel1 = null
              this.panel2 = 0
              this.tabIndex = 0
              this.isDialogPAAlertDetailShown = true
            }
          },
          {
            target: '#tab-menu-pdpa',
            header: {
              title: 'Activity Tracking'
            },
            content: `<span>แท็บที่ 2 จะเป็นตารางแสดงข้อมูลผู้ที่ไม่ได้รับการอนุญาติ<br>ในการเข้าใช้งานอุปกรณ์ตามที่ผู้ใช้ตั้งค่าไว้</span>`,
            params: {
              highlight: false,
              enableScrolling: false
            },
            before: () => {
              this.tabIndex = 1
              this.isDialogPAAlertDetailShown = false
              this.isDialogATAlertDetailShown = false
              setTimeout(() => {
                this.datatables = [
                  {
                    alertname: 'แจ้งเตือนการละเมิดเข้าถึงข้อมูลส่วนบุคคล',
                    detail: [
                        {
                            event: [
                                {
                                  _id: '60a4fdc05e03a64e9a0dc74d',
                                  username: 'sutasinee_sa',
                                  eventcount: '7304'
                                },
                                {
                                  _id: '60a4fdc05e03a64e9a0dc74c',
                                  username: 'promporn_la',
                                  eventcount: '1261'
                                },
                                {
                                  _id: '60a4fdc05e03a64e9a0dc74a',
                                  username: 'kulada_na',
                                  eventcount: '514'
                                },
                                {
                                  _id: '60a4fdc05e03a64e9a0dc749',
                                  username: 'wasitthee_ph',
                                  eventcount: '408'
                                },
                              {
                                  _id: '60a4fdc05e03a64e9a0dc748',
                                  username: '-',
                                  eventcount: '311'
                                }
                            ],
                            _id: '60a4fdc05e03a64e9a0dc70b',
                            hostname: 'example.co.th'
                        },
                        {
                            event: [
                                {
                                  _id: '60a4fdc05e03a64e9a0dc70a',
                                  username: 'thanakrit',
                                  eventcount: '1934'
                                },
                                {
                                  _id: '60a4fdc05e03a64e9a0dc709',
                                  username: 'sawangpong.l',
                                  eventcount: '1440'
                                },
                                {
                                  _id: '60a4fdc05e03a64e9a0dc708',
                                  username: 'auttawut',
                                  eventcount: '607'
                                },
                                {
                                  _id: '60a4fdc05e03a64e9a0dc707',
                                  username: 'pakkanate',
                                  eventcount: '575'
                                },
                                {
                                  _id: '60a4fdc05e03a64e9a0dc706',
                                  username: 'kittinan',
                                  eventcount: '563'
                                },
                                {
                                  _id: '60a4fdc05e03a64e9a0dc705',
                                  username: 'kittithad.g',
                                  eventcount: '446'
                                },
                                {
                                  _id: '60a4fdc05e03a64e9a0dc704',
                                  username: 'kittiphong',
                                  eventcount: '431'
                                },
                                {
                                  _id: '60a4fdc05e03a64e9a0dc703',
                                  username: 'nattapon.s',
                                  eventcount: '422'
                                },
                                {
                                  _id: '60a4fdc05e03a64e9a0dc702',
                                  username: 'wannasiri',
                                  eventcount: '90'
                                },
                                {
                                  _id: '60a4fdc05e03a64e9a0dc701',
                                  username: 'patiphan.t',
                                  eventcount: '72'
                                },
                                {
                                  _id: '60a4fdc05e03a64e9a0dc700',
                                  username: 'taninvat',
                                  eventcount: '63'
                                }
                            ],
                            _id: '60a4fdc05e03a64e9a0dc6ff',
                            hostname: 'Hostfileshare'
                        },
                        {
                            event: [
                                {
                                  _id: '60a4fdc05e03a64e9a0dc6fe',
                                  username: 'xiuxiu',
                                  eventcount: '291'
                                }
                            ],
                            _id: '60a4fdc05e03a64e9a0dc6fd',
                            hostname: 'Hostwindow'
                        },
                        {
                            event: [
                                {
                                  _id: '60a4fdc05e03a64e9a0dc6fc',
                                  username: 'patarawoot',
                                  eventcount: '53'
                                },
                                {
                                  _id: '60a4fdc05e03a64e9a0dc6fb',
                                  username: 'kamonwan',
                                  eventcount: '12'
                                }
                            ],
                            _id: '60a4fdc05e03a64e9a0dc6fa',
                            hostname: 'ilog.ai'
                        }
                    ],
                    _id: '60a4fdc05e03a64e9a0dc6f9',
                    time: 'Wed May 19 2021 19:00:00 GMT+0700 (Indochina Time)',
                    rangetime: '19/05  18:00 น.   -  19/05  19:00 น.'
                  }
                ]
                this.datatables = this.datatables.map((item) => {
                  let host_tmp = ''
                  item.detail.map(el => {
                    host_tmp += el.hostname + ', '
                  })
                  return {
                    _id: item._id,
                    datetime: item.time,
                    period: item.rangetime,
                    msg: item.alertname,
                    hostname: host_tmp,
                    details: item.detail
                  }
                })
              }, 1000)
            }
          },
          {
            target: '#atDetail',
            header: {
              title: 'เวลาทำงาน'
            },
            content: `<span>ส่วนแรกจะเป็นช่วงเวลาที่ระบบทำการ Query log</span>`,
            params: {
              highlight: true,
              enableScrolling: false
            },
            before: () => {
              this.seeDetails(this.datatables[0], 'AT')
            }
          },
          {
            target: '#atResult',
            header: {
              title: 'รายละเอียดผลการทำงาน'
            },
            content: `<span>ส่วนที่สองจะเป็นรายชื่อที่ไม่ได้รับอนุญาติในการเข้าใช้งาน<br>แต่ละ Host ตามที่ผู้ใช้ตั้งค่าไว้</span>`,
            params: {
              highlight: true,
              enableScrolling: false
            },
            before: () => {
              this.seeDetails(this.datatables[0], 'AT')
            }
          },
          {
            target: '#tab-search-at',
            header: {
              title: 'Support iLog'
            },
            content: `<span>หากคุณมีข้อสงสัยเพิ่มเติมสามารถคลิกที่ปุ่มเมนู Manual ที่แถบเมนู <br>หรือสามารถติดต่อหา Support iLog ได้ผ่านทุกช่องทาง</span>`,
            params: {
              highlight: false,
              enableScrolling: false
            },
            before: () => {
              this.isDialogATAlertDetailShown = false
            }
          }
        ]
       }
    },
    async created () {
        this.token = sessionStorage.getItem('user-token')
        this.decoded = jwtDecode(this.token)
        this.ampid = this.decoded.ampid
        this.searchFromAlert = JSON.parse(sessionStorage.getItem('iLog-search-alert'))
        this.user_id = this.decoded._id
        this.role = this.decoded.role
        this.user = this.decoded.username
        await this.getIndex()
        if (this.searchFromAlert) {
            this.tabIndex = this.searchFromAlert.index
            this.device = this.searchFromAlert.device
            this.abStartTime = this.searchFromAlert.startdate
            this.abEndTime = this.searchFromAlert.enddate
            this.showFilter()
            // setTimeout(() => {
            //     // this.abStartTime = this.searchFromAlert.startdate
            //     // this.abEndTime = this.searchFromAlert.enddate
            //     this.showFilter()
            // }, 100)
            sessionStorage.removeItem('iLog-search-alert')
        } else {
          await this.getDataTablePDPA()
        }
        if (this.role === 'user') {
            let response = await axios.post(apiUrl + '/api/status/recommend', {
                command: 'get'
            })
            this.recommend = response.data.alertpdpa
        }
        // await this.getDataTablePDPA()
    },
    methods: {
        async getDataTablePDPA () {
            this.loadTablePdpaAlert = true
            this.startTime = Date.parse(this.abStartTime)
            this.endTime = Date.parse(this.abEndTime)
            let response = await axios.post(apiUrl + '/api/query/reworkAlert', {
                command: 'tcca',
                index: this.devices,
                selected: this.device,
                start: this.startTime,
                end: this.endTime,
                search: this.search,
                page: this.page - 1,
                perPage: this.perPage
            })
            if (response.data) {
                let page = Math.floor(response.data.pages / 10)
                page === 0 ? this.allPages = 1 : this.allPages = page + 1

                this.datatablesPdpaAlert = []
                response.data.table.map(el => {
                    this.datatablesPdpaAlert.push({
                        datetime: el.datetime,
                        time: Date.parse(el.datetime),
                        device: el.device,
                        event: el.event,
                        name: el.name,
                        range: el.range,
                        _id: el._id
                    })
                })

                this.loadTablePdpaAlert = false
            } else {
                this.page = 1
                this.allPages = 1
                this.datatablesPdpaAlert = []
                this.loadTablePdpaAlert = false
                // this.finishLoadAlertPDPA = true
            }
        },
        async getDataTableActivity () {
            this.loadTable = true
            this.startTime = Date.parse(this.abStartTime)
            this.endTime = Date.parse(this.abEndTime)
            let response = await axios.post(apiUrl + '/api/query/reworkAlert', {
                command: 'pdpa',
                index: this.devices,
                selected: this.device,
                start: this.startTime,
                end: this.endTime,
                search: this.search,
                page: this.page - 1,
                perPage: this.perPage
            })
            // console.log(response.data)
            if (response.data.table) {
                let page = Math.floor(response.data.pages / 10)
                page === 0 ? this.allPages = 1 : this.allPages = page + 1

                this.datatables = []
                this.datatables = response.data.table.map((item) => {
                    let host_tmp = ''
                    item.detail.map(el => {
                        host_tmp += el.hostname + ', '
                    })
                    return {
                        _id: item._id,
                        datetime: new Date(item.time),
                        order: Date.parse(item.time),
                        period: item.rangetime,
                        msg: item.alertname,
                        hostname: host_tmp,
                        details: item.detail
                    }
                })

                this.loadTable = false
                // this.finishLoadAlertAT = true
            } else {
                this.page = 1
                this.allPages = 1
                this.datatables = []
                this.loadTable = false
                // this.finishLoadAlertAT = true
            }
        },
        goto () {
            this.page = parseInt(this.gotoPage)
        },
        async getIndex () {
          let response = await axios.post(apiUrl + '/api/query/getAllIndex', {
            id: this.user_id,
            command: 'pdpa'
          })
          // return response.data
          // console.log(response.data)
          response.data.map(el => this.devices.push(el))
        },
        // async getAlertActivityTracking () {
        //   this.loadTable = true
        //   let response = await axios.get(apiUrl + '/api/whitelist/getalerts')
        //   this.datatables = response.data.map((item) => {
        //     let host_tmp = ''
        //     item.detail.map(el => {
        //       host_tmp += el.hostname + ', '
        //     })
        //     return {
        //       _id: item._id,
        //       datetime: item.time,
        //       order: Date.parse(item.time),
        //       period: item.rangetime,
        //       msg: item.alertname,
        //       hostname: host_tmp,
        //       details: item.detail
        //     }
        //   })
        //   this.finishLoadAlertAT = true
        //   this.loadTable = false
        // },
        // async getAlertPdpa () {
        //   this.loadTablePdpaAlert = true
        //   let response = await axios.post(apiUrl + '/api/query/getalerts', {
        //     command: 'pdpa'
        //   })
        //   if (response.data) {
        //     // this.datatablesPdpaAlert = []
        //     // setTimeout(() => {
        //       response.data.map(el => {
        //         this.datatablesPdpaAlert.push({
        //           datetime: el.datetime,
        //           time: Date.parse(el.datetime),
        //           device: el.device,
        //           event: el.event,
        //           name: el.name,
        //           range: el.range,
        //           _id: el._id
        //         })
        //       })
        //     // }, 100)
        //   }
        //   // this.datatablesPdpaAlert = response.data
        //   this.finishLoadAlertPDPA = true
        //   this.loadTablePdpaAlert = false
        // },
        // customFilterAT (datatables) {
        //   if (this.abStartTime !== '' && this.abEndTime !== '' && this.showFilterData) {
        //     this.startTime = Date.parse(this.abStartTime)
        //     this.endTime = Date.parse(this.abEndTime)
        //     let newDatatables = []
        //     datatables.map((item) => {
        //       let time = Date.parse(item.datetime)
        //       if (time >= this.startTime && time <= this.endTime) newDatatables.push(item)
        //     })
        //     this.showFilterData = false
        //     return newDatatables
        //   } else {
        //     return datatables
        //   }
        // },
        // customFilterPA (datatables, search) {
        //     if (this.device) {
        //       if (this.device !== 'All') {
        //           datatables = datatables.filter(el => el.device === this.device)
        //       }
        //     }
        //     if (search !== '') {
        //       let regex = new RegExp(search)
        //       datatables = datatables.filter(el => regex.test(el.datetime) || regex.test(el.name) || regex.test(el.device) || regex.test(el.range))
        //     }
        //     if (this.abStartTime !== '' && this.abEndTime !== '' && this.showFilterData) {
        //       this.startTime = Date.parse(this.abStartTime)
        //       this.endTime = Date.parse(this.abEndTime)
        //       let newDatatables = []
        //       datatables.map((item) => {
        //         let time = Date.parse(item.datetime)
        //         if (time >= this.startTime && time <= this.endTime) newDatatables.push(item)
        //       })
        //       datatables = newDatatables
        //       this.showFilterData = false
        //       return datatables
        //     } else {
        //       return datatables
        //     }
        // },
        showFilter () {
        //   this.showFilterData = true
            if (this.tabIndex === 0) {
                this.page = 1
                this.getDataTablePDPA()
            } else {
                this.page = 1
                this.getDataTableActivity()
            }
            window.analytics.track(`[AlertHistory][PDPA][SubmitTime]`, {
                value: {
                  start: this.abStartTime,
                  end: this.abEndTime
                }
            }, {
                integrations: {
                Amplitude: {
                    'session_id': this.ampid
                }
                }
            })
        },
        seeDetails (e, table) {
          // console.log(e)
          if (table === 'AT') {
            window.analytics.track(`[AlertHistory][PDPA][ActivityTracking][Details]`, {}, {
              integrations: {
                Amplitude: {
                  'session_id': this.ampid
                }
              }
            })
            this.panel = []
            this.seedetail = e.details
            this.datetime = e.datetime
            this.period = e.period
            this.msg = e.msg
            this.hostname = e.hostname
            this.datatablesDetail = e.details
            this.headerDetail = [
                {
                  text: 'Username',
                  value: 'username',
                  align: 'center',
                  class: 'white--text body-2 grey darken-3',
                  sortable: true
                },
                {
                  text: 'Event Count',
                  value: 'eventcount',
                  align: 'center',
                  class: 'white--text body-2 grey darken-3',
                  sortable: true
                },
                {
                  text: 'Action',
                  value: 'action',
                  align: 'center',
                  class: 'white--text body-2 grey darken-3',
                  sortable: false
                }
            ]
            this.isDialogATAlertDetailShown = true
          } else if (table === 'PA') {
            window.analytics.track(`[AlertHistory][PDPA][Details]`, {}, {
              integrations: {
                Amplitude: {
                  'session_id': this.ampid
                }
              }
            })
            this.panel1 = null
            this.panel2 = null
            this.alertname = e.name
            this.status = 'DECTECED'
            this.alertdevice = e.device
            this.total = e.event[0].total
            this.datetime = e.datetime
            this.range = e.range
            this.query = e.event[0].alertbox.query
            this.type = e.event[0].alertbox.eventTrigger
            this.field = e.event[0].alertbox.targetField
            this.fieldalert = e.event[0].alertbox.fieldalet
            this.rule = e.event[0].alertbox.trigger
            this.time = e.event[0].alertbox.raw_interval
            this.email = e.event[0].alertbox.email
            this.seedetail = e.event[0].data
            if (this.type === 'count') {
              this.headerDetail = [
              {
                  text: this.field + ' *',
                  value: 'key',
                  align: 'center',
                  class: 'white--text body-2 grey darken-3',
                  sortable: true
                },
                {
                  text: 'Event Count',
                  value: 'doc_count',
                  align: 'center',
                  class: 'white--text body-2 grey darken-3',
                  sortable: true
                }
              ]
            } else {
              this.headerDetail = [
              {
                  text: this.fieldalert + ' *',
                  value: 'key',
                  align: 'center',
                  class: 'white--text body-2 grey darken-3',
                  sortable: true
                },
                {
                  text: 'Result',
                  value: 'doc_count',
                  align: 'center',
                  class: 'white--text body-2 grey darken-3',
                  sortable: true
                }
              ]
            }
            this.isDialogPAAlertDetailShown = true
          }
          // const response = await axios.get(apiUrl + '/api/whitelist/getalerts')
        },
        async deleteAlertAT () {
          this.loadTable = true
          this.isDialogConfirmDeleteATShown = false
          let alertid = []
          if (this.selected.length > 0) {
            this.selected.map(item => {
              alertid.push(item._id)
            })
          }
          window.analytics.track(`[AlertHistory][PDPA][ActivityTracking][Delete]`, {}, {
            integrations: {
              Amplitude: {
                'session_id': this.ampid
              }
            }
          })
          let response = await axios.post(apiUrl + '/api/query/deleteAlertActivity', alertid)
          if (response.data.msg === 'success') {
            this.loadTable = false
            this.snackbartext = 'Delete selected alert sucess'
            this.snackbar = true
            this.selected = []
            await this.getDataTableActivity()
          } else {
            this.loadTable = false
            this.snackbartext = 'Please try again later'
            this.snackbar = true
            this.selected = []
            await this.getDataTableActivity()
          }
        },
        async deleteAlertPA () {
          // this.loadTable = true
          this.loadTablePdpaAlert = true
          this.isDialogConfirmDeleteShown = false
          let alertid = []
          if (this.selected.length > 0) {
            this.selected.map(item => {
              alertid.push(item._id)
            })
          }
          window.analytics.track(`[AlertHistory][PDPA][Delete]`, {
            value: {
              alert: alertid
            }
          }, {
            integrations: {
              Amplitude: {
                'session_id': this.ampid
              }
            }
          })
          let response = await axios.post(apiUrl + '/api/query/deleteAlertTcca', alertid)
          if (response.data.msg === 'success') {
            // this.loadTable = false
            this.loadTablePdpaAlert = false
            this.snackbartext = 'Delete selected alert success'
            this.snackbar = true
            this.selected = []
            this.getDataTablePDPA()
          } else {
            // this.loadTable = false
            this.loadTablePdpaAlert = false
            this.snackbartext = 'Please try again later'
            this.snackbar = true
            this.selected = []
            this.getDataTablePDPA()
          }
        },
        addUser (valuse, host) {
          this.username = valuse.username
          this.hostname = host
          this.isDialogConfirmAdduserShown = true
        },
        async addUserToWhitelist () {
          window.analytics.track(`[Alert History][PDPA][Activity Tracking][Details][Host][Add user]`, {}, {
            integrations: {
              Amplitude: {
                'session_id': this.ampid
              }
            }
          })
          this.isDialogConfirmAdduserShown = false
          await axios.post(apiUrl + '/api/whitelist/adduser', {
              username: this.username,
              hostname: this.hostname
          })
          this.snackbartext = `Add ${this.username} to whitelist success`
          this.snackbar = true
        },
        toSearch (e, type) {
          window.analytics.track(`[Alert History][PDPA][Detailes][Search]`, {
            value: {
              start: this.abStartTime,
              end: this.abEndTime,
              device: this.alertdevice,
              text: e
            }
          }, {
            integrations: {
              Amplitude: {
                'session_id': this.ampid
              }
            }
          })
          // console.log(e)
          // console.log(type)
          let dataDateTime = new Date(this.datetime)
          let dateTimeST = this.range.split('-')[0].trim().split(/(\d\d)/)
          let dateTimeEND = this.range.split('-')[1].trim().split(/(\d\d)/)
          // let newDateST = new Date(dataDateTime.getFullYear(), dateTimeST[3] - 1, dateTimeST[1], dateTimeST[5], dateTimeST[7], 0)
          // let newDateEND = new Date(dataDateTime.getFullYear(), dateTimeEND[3] - 1, dateTimeEND[1], dateTimeEND[5], dateTimeEND[7], 0)
          let newDateST = `${dataDateTime.getFullYear()}-${dateTimeST[3]}-${dateTimeST[1]}T${dateTimeST[5]}:${dateTimeST[7]}:10`
          let newDateEND = `${dataDateTime.getFullYear()}-${dateTimeEND[3]}-${dateTimeEND[1]}T${dateTimeEND[5]}:${dateTimeEND[7]}:10`
          let textSearch
          if (type === '1') {
            textSearch = {text: e[0].split('text: ')[1], device: this.alertdevice, startdate: newDateST, enddate: newDateEND}
          } else if (type === '2') {
            textSearch = {text: e, device: this.alertdevice, startdate: newDateST, enddate: newDateEND}
          }
          sessionStorage.setItem('iLog-search', JSON.stringify(textSearch))
          let routeData = this.$router.resolve({name: 'dashboardpdpa'})
          window.open(routeData.href, '_blank')
          sessionStorage.removeItem('iLog-search')
        },
        toSearchAT (e, type) {
          let dataDateTime = new Date(this.datetime)
          let dateTimeST = this.period.split('-')[0].trim().split(/(\d\d)/)
          let dateTimeEND = this.period.split('-')[1].trim().split(/(\d\d)/)
          // let newDateST = new Date(dataDateTime.getFullYear(), dateTimeST[3] - 1, dateTimeST[1], dateTimeST[5], dateTimeST[7], 0)
          // let newDateEND = new Date(dataDateTime.getFullYear(), dateTimeEND[3] - 1, dateTimeEND[1], dateTimeEND[5], dateTimeEND[7], 0)
          let newDateST = `${dataDateTime.getFullYear()}-${dateTimeST[3]}-${dateTimeST[1]}T${dateTimeST[5]}:${dateTimeST[7]}:10`
          let newDateEND = `${dataDateTime.getFullYear()}-${dateTimeEND[3]}-${dateTimeEND[1]}T${dateTimeEND[5]}:${dateTimeEND[7]}:10`
          let textSearch
          if (type === '1') {
            textSearch = {text: '', device: 'pdpa', startdate: newDateST, enddate: newDateEND}
          } else if (type === '2') {
            textSearch = {text: '', device: 'pdpa', startdate: newDateST, enddate: newDateEND}
          } else if (type === '3') {
            textSearch = {text: `username:${e}`, device: 'pdpa', startdate: newDateST, enddate: newDateEND}
          }
          sessionStorage.setItem('iLog-search', JSON.stringify(textSearch))
          let routeData = this.$router.resolve({name: 'dashboardpdpa'})
          window.open(routeData.href, '_blank')
          window.analytics.track(`[Alert History][PDPA][Activity Tracking][Search]`, {
            value: {
              start: newDateST,
              end: newDateEND,
              device: 'pdpa',
              text: e
            }
          }, {
            integrations: {
              Amplitude: {
                'session_id': this.ampid
              }
            }
          })
          sessionStorage.removeItem('iLog-search')
        },
        async finishStepTour () {
          this.isDialogPAAlertDetailShown = false
          this.isDialogATAlertDetailShown = false
          setTimeout(() => {
            this.tabIndex = 0
            this.getDataTablePDPA()
            // this.getDataTableActivity()
          }, 500)
          await axios.post(apiUrl + '/api/status/recommend', {
            command: 'disalertpdpa'
          })
        }
    },
    watch: {
      tabIndex: async function () {
        if (this.tabIndex === 0) {
            window.analytics.track('[Alert History][PDPA]', {}, {
                integrations: {
                Amplitude: {
                    'session_id': this.ampid
                }
                }
            })
            this.search = ''
            if (this.searchFromAlert) {
              this.abStartTime = ''
              this.abEndTime = ''
            }
            // this.abStartTime = ''
            // this.abEndTime = ''
            this.device = 'All'
            //   this.getAlertPdpa()
            this.page = 1
            this.allPages = 1
            this.getDataTablePDPA()
            await axios.post(apiUrl + '/api/dashboard/stage', {
                type: 'menu',
                username: this.user,
                menu: 'alertHistorypdpa',
                submenu: this.tabMenu[this.tabIndex]
            })
        } else if (this.tabIndex === 1) {
            window.analytics.track('[Alert History][PDPA][Activity Tracking]', {}, {
                integrations: {
                Amplitude: {
                    'session_id': this.ampid
                }
                }
            })
            this.search = ''
            if (this.searchFromAlert) {
              this.abStartTime = ''
              this.abEndTime = ''
            }
            // this.abStartTime = ''
            // this.abEndTime = ''
            this.device = 'All'
            // await this.getAlertActivityTracking()
            this.page = 1
            this.allPages = 1
            this.getDataTableActivity()
            await axios.post(apiUrl + '/api/dashboard/stage', {
                type: 'menu',
                username: this.user,
                menu: 'alertHistorypdpa',
                submenu: this.tabMenu[this.tabIndex]
            })
        }
        sessionStorage.removeItem('iLog-search-alert')
      },
      finishLoadAlertPDPA: function () {
        if (this.finishLoadAlertPDPA) {
          if (this.searchFromAlert) {
            setTimeout(() => {
              this.abStartTime = this.searchFromAlert.startdate
              this.abEndTime = this.searchFromAlert.enddate
              this.showFilter()
            }, 500)
          }
        }
      },
      finishLoadAlertAT: function () {
        if (this.finishLoadAlertAT) {
          if (this.searchFromAlert) {
            setTimeout(() => {
              this.abStartTime = this.searchFromAlert.startdate
              this.abEndTime = this.searchFromAlert.enddate
              this.showFilter()
            }, 500)
          }
        }
      },
      recommend: function () {
        if (this.recommend && this.$router.history.current.name === 'alertHistorypdpa') {
          setTimeout(() => {
            this.$tours['recommand-tour-al-pdpa'].start()
          }, 1000)
        }
      },
      abStartTime: async function () {
        window.analytics.track(`[AlertHistory][PDPA][StartTime]`, {}, {
          integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        })
        if (!this.abStartTime) {
          if (this.tabIndex === 0) {
            // this.datatablesPdpaAlert = []
            // await this.getAlertPdpa()
            this.getDataTablePDPA()
          } else {
              this.getDataTableActivity()
            // this.datatables = []
            // await this.getAlertActivityTracking()
          }
        }
      },
      abEndTime: async function () {
        window.analytics.track(`[AlertHistory][PDPA][EndTime]`, {}, {
          integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        })
        if (!this.abEndTime) {
          if (this.tabIndex === 0) {
            // this.datatablesPdpaAlert = []
            // await this.getAlertPdpa()
            this.page = 1
            this.getDataTable()
          } else {
            this.page = 1
            this.getDataTableActivity()
            // this.datatables = []
            // await this.getAlertActivityTracking()
          }
        }
      },
    //   search: function () {
    //     window.analytics.track(`[AlertHistory][PDPA][Search]`, {
    //         value: {
    //             keyword: this.search
    //         }
    //     }, {
    //         integrations: {
    //             Amplitude: {
    //             'session_id': this.ampid
    //             }
    //         }
    //     })
    //   },
      panel1: function () {
        if (this.panel1 === 0) {
          window.analytics.track(`[AlertHistory][PDPA][Details][Setting]`, {}, {
            integrations: {
              Amplitude: {
                'session_id': this.ampid
              }
            }
          })
        }
      },
      panel2: function () {
        if (this.panel2 === 0) {
          window.analytics.track(`[AlertHistory][PDPA][Details][Alert]`, {}, {
            integrations: {
              Amplitude: {
                'session_id': this.ampid
              }
            }
          })
        }
      },
      page: function () {
        if (this.tabIndex === 0) {
            this.getDataTablePDPA()
        } else {
            this.getDataTableActivity()
        }
        this.gotoPage = this.page
      },
      device: function () {
        this.page = 1
        this.getDataTablePDPA()
      },
      search: function () {
        window.analytics.track(`[AlertHistory][PDPA][Search]`, {
            value: {
                keyword: this.search
            }
        }, {
            integrations: {
                Amplitude: {
                'session_id': this.ampid
                }
            }
        })
        if (this.tabIndex === 0) {
            this.page = 1
            this.getDataTablePDPA()
        } else {
            this.page = 1
            this.getDataTableActivity()
        }
      }
    }
}
</script>

<style scoped>
.container-pdpa-alert {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  margin-bottom: 60px;
}
.card {
  border-radius: 3px;
  color: #cccccc;
}
.tine_header {
  text-align: left;
  color: #cccccc;
}
.table-detail {
  width: 100%;
  text-align: left;
  border-collapse: initial;
}

.table-detail > tr {
  background-color: transparent !important;
  border: none;
}

.table-detail > tr > td > span{
  color: #26A69A;
  margin: 0 3px;
}

.blockheading {
  /* background-color: #0091EA; */
  color: #616161;
  padding-left: 9px;
  padding-top: 3px;
  margin-bottom: 5px;
  border-radius: 20px;
  display: inline-block;
  width: 145px;
  height: 25px;
}
.blockresult {
  /* background-color: #43A047; */
  color: #4DB6AC;
  padding-left: 9px;
  padding-right: 9px;
  /* padding-top: px; */
  border-radius: 20px;
  text-decoration-line: underline;
  /* color: #4DB6AC; */
  cursor: pointer;
  font-size: 16px;
  margin-left: 8px;
}
#new {
  color: #f7184d;
  position: absolute;
  top: 163px;
  /* right: 257px; */
  transform:rotate(15deg);
  /* left: 55px; */
  font-size: 0.8rem;
  /* font-weight: bold; */
}

.recommend {
  margin: 8px 0;
  font-size: 12px;
  color: #EF5350;
}

.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0,0,0,.8);
}
.tour-body {
  max-width: 900px !important;
  min-width: 450px !important;
  max-height: 300px !important;
  padding: 0 !important;
  margin: auto !important;
  background-color: #212121 !important;
}
.tour-btn-start {
  color: #fff !important;
  background-color: #009688 !important;
  box-shadow: none !important;
  border-radius: 13px !important;
  width: 260px !important;
  outline: none !important;
  margin: 0 auto !important;
  margin-top: 10px !important;
  text-transform: none !important;
  font-size: 16px !important;
}
.tour-btn-skip {
  position: relative !important;
  left: 190px !important;
  text-transform: none !important;
  outline: none !important;
  font-size: 13px !important;
  margin: 10px 0 !important;
  color: #616161 !important;
  text-decoration-line: underline !important;
  font-style: normal !important;
  font-weight: normal !important;
}
.tour-btn-back {
  margin:0 10px !important;
  color: #212121 !important;
  outline: none !important;
  background-color: #fff !important;
  text-transform: none !important;
  box-shadow: none !important;
  border-radius: 13px !important;
}
.tour-btn-next {
  margin:0 10px;
  color: #fff !important;
  outline: none !important;
  background-color: #009688  !important;
  text-transform: none !important;
  box-shadow: none !important;
  border-radius: 13px !important;
}
.tour-btn-finish {
  color: #fff !important;
  outline: none !important;
  background-color: #009688  !important;
  text-transform: none !important;
  box-shadow: none !important;
  border-radius: 13px !important;
  width: 25px !important;
  margin: 20px auto;
}
.tour-header {
  border-bottom: 1px solid #BDBDBD !important;
  margin: 12px 30px !important;
  padding: 0 !important;
}
.tour-content {
  font-size: 14px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/alertHistoryPDPA_new.vue